const cdnjs = {
    "jquery": "https://cdn.jsdelivr.net/npm/jquery@3.5.1/dist/jquery.min.js",
    "slick": "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js",
    "slick_css": "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.css",
    "slick_theme": "https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.min.css",
    "lightgallery": "https://cdn.jsdelivr.net/npm/lightgallery.js@1.4.0/dist/js/lightgallery.min.js",
    "lightgallery_css": "https://cdn.jsdelivr.net/npm/lightgallery.js@1.4.0/dist/css/lightgallery.min.css"
};